import { useContext } from 'react';
import { SyncContext } from 'contexts/sync';
const CartProductQuantity = (props) => {
    const { getProductQuantity } = useContext(SyncContext);
    return props.PrID ? getProductQuantity(props.PrID) : ''
}

export default CartProductQuantity;